(function () {
  'use strict';

  var config = window.SIBCustomDesignActivityConfig || {};
  if (!config.endpoint || !config.cookieName || !config.cartAttributeKey || !window.fetch) return;

  var COOKIE_DAYS = 30;
  var COOKIE_MAX_AGE = COOKIE_DAYS * 24 * 60 * 60;
  var MAX_BATCH_BYTES = 700 * 1024;
  var QUEUE_KEY = 'sib_cd_activity_queue';
  var SEQUENCE_PREFIX = 'sib_cd_activity_sequence:';
  var UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var CART_MUTATION_PATTERN = /\/cart\/(add|change|update|clear)\.js(?:[?#]|$)/i;
  var nativeFetch = window.fetch.bind(window);
  var trackingId = readCookie(config.cookieName);
  var active = UUID_PATTERN.test(trackingId || '');
  var queue = readQueue();
  var sending = false;
  var flushTimer = null;
  var retryTimer = null;
  var snapshotTimer = null;
  var stateTimer = null;
  var pendingSnapshotReasons = [];
  var cartAttributePromise = null;
  var cartAttributeRetryCount = 0;
  var currentCartToken = null;
  var recentAnomalies = {};
  var pendingAnomalies = active && Array.isArray(window.__sibCustomDesignPendingAnomalies)
    ? window.__sibCustomDesignPendingAnomalies.slice()
    : [];
  window.__sibCustomDesignPendingAnomalies = [];

  if (!active) queue = [];

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    var bytes = new Uint8Array(16);
    if (window.crypto && typeof window.crypto.getRandomValues === 'function') {
      window.crypto.getRandomValues(bytes);
    } else {
      for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
    }
    bytes[6] = (bytes[6] & 15) | 64;
    bytes[8] = (bytes[8] & 63) | 128;
    var hex = Array.prototype.map.call(bytes, function (byte) {
      return byte.toString(16).padStart(2, '0');
    }).join('');
    return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' +
      hex.slice(16, 20) + '-' + hex.slice(20);
  }

  function readCookie(name) {
    var prefix = name + '=';
    var parts = document.cookie ? document.cookie.split(';') : [];
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) === 0) return decodeURIComponent(part.slice(prefix.length));
    }
    return null;
  }

  function writeCookie(id) {
    var expires = new Date(Date.now() + COOKIE_MAX_AGE * 1000).toUTCString();
    var secure = window.location.protocol === 'https:' ? '; Secure' : '';
    document.cookie = config.cookieName + '=' + encodeURIComponent(id) +
      '; Path=/; Max-Age=' + COOKIE_MAX_AGE + '; Expires=' + expires + '; SameSite=Lax' + secure;
  }

  function storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (error) { return null; }
  }

  function storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (error) { /* storage is optional */ }
  }

  function readQueue() {
    try {
      var saved = JSON.parse(storageGet(QUEUE_KEY) || '[]');
      return Array.isArray(saved) ? saved : [];
    } catch (error) {
      return [];
    }
  }

  function saveQueue() {
    // Bound failed/offline storage. The newest events are most useful when
    // diagnosing the state immediately before checkout.
    if (queue.length > 100) queue = queue.slice(queue.length - 100);
    storageSet(QUEUE_KEY, JSON.stringify(queue));
  }

  function nextSequence() {
    var key = SEQUENCE_PREFIX + trackingId;
    var next = parseInt(storageGet(key) || '0', 10);
    if (!isFinite(next) || next < 0) next = 0;
    next += 1;
    storageSet(key, String(next));
    return next;
  }

  function safeUrl(value) {
    if (!value) return null;
    try {
      var parsed = new URL(value, window.location.origin);
      // Query strings and fragments can contain account tokens or other PII.
      return parsed.origin + parsed.pathname;
    } catch (error) {
      return String(value).split(/[?#]/)[0].slice(0, 2048);
    }
  }

  function utf8ByteLength(value) {
    var length = 0;
    for (var i = 0; i < value.length; i++) {
      var code = value.charCodeAt(i);
      if (code <= 0x7f) length += 1;
      else if (code <= 0x7ff) length += 2;
      else if (code >= 0xd800 && code <= 0xdbff && i + 1 < value.length &&
               value.charCodeAt(i + 1) >= 0xdc00 && value.charCodeAt(i + 1) <= 0xdfff) {
        length += 4;
        i += 1;
      } else length += 3;
    }
    return length;
  }

  function pageContext() {
    var page = config.page || {};
    return {
      page_url: safeUrl(window.location.href),
      page_path: window.location.pathname.slice(0, 1024),
      referrer_url: safeUrl(document.referrer),
      page_type: page.type || null,
      template_name: page.template || null,
      product_id: page.productId == null ? null : String(page.productId),
      product_handle: page.productHandle || null
    };
  }

  function enqueue(action, source, data, options) {
    if (!active) return;
    options = options || {};
    var context = pageContext();
    queue.push({
      event_uid: uuid(),
      sequence_no: nextSequence(),
      client_date: new Date().toISOString(),
      action: action,
      source: source || null,
      page_url: context.page_url,
      page_path: context.page_path,
      referrer_url: context.referrer_url,
      page_type: context.page_type,
      template_name: context.template_name,
      product_id: context.product_id,
      product_handle: context.product_handle,
      cart_token: options.cartToken || currentCartToken || null,
      is_trigger: options.isTrigger === true,
      data: data == null ? null : data
    });
    saveQueue();
    scheduleFlush(options.immediate === true ? 0 : 250);
  }

  function errorSummary(error) {
    if (error == null) return {};
    if (typeof error === 'string') return { message: error.slice(0, 1000) };
    return {
      name: error.name ? String(error.name).slice(0, 120) : null,
      message: error.message ? String(error.message).slice(0, 1000) : String(error).slice(0, 1000),
      code: error.code ? String(error.code).slice(0, 160) : null,
      stack: error.stack ? String(error.stack).slice(0, 4000) : null
    };
  }

  // Caught workflow failures do not reach window.error. Callers use this
  // reporter immediately before showing a warning/error modal or after an
  // invariant check fails. A short dedupe window prevents a failed request,
  // its catch handler, and its modal from flooding the same timeline.
  function reportAnomaly(code, source, details, options) {
    if (!active) return;
    options = options || {};
    details = details || {};
    var error = options.error || details.error;
    var data = {
      code: String(code || 'unknown-anomaly').slice(0, 160),
      severity: options.severity === 'warning' ? 'warning' : 'error',
      message: details.message == null ? null : String(details.message).slice(0, 1000),
      modal_shown: options.modalShown === true
    };
    Object.keys(details).forEach(function (key) {
      if (['error', 'code', 'severity', 'modal_shown', 'message'].indexOf(key) === -1 &&
          details[key] !== undefined) data[key] = details[key];
    });
    if (error) data.error = errorSummary(error);

    var detailFingerprint = '';
    try { detailFingerprint = JSON.stringify(details).slice(0, 1500); } catch (ignore) { /* best-effort dedupe */ }
    var dedupeKey = [
      data.code,
      source || '',
      data.message || '',
      data.error && data.error.message || '',
      detailFingerprint
    ].join('|');
    var now = Date.now();
    if (!options.allowDuplicate && recentAnomalies[dedupeKey] && now - recentAnomalies[dedupeKey] < 5000) return;
    recentAnomalies[dedupeKey] = now;
    Object.keys(recentAnomalies).forEach(function (key) {
      if (now - recentAnomalies[key] > 60000) delete recentAnomalies[key];
    });

    enqueue(data.severity === 'warning' ? 'anomaly' : 'error', source || 'custom-design', data, {
      cartToken: options.cartToken,
      immediate: true
    });
    if (options.snapshot !== false) scheduleCartSnapshot('anomaly:' + data.code);
  }

  function scheduleFlush(delay) {
    if (flushTimer) window.clearTimeout(flushTimer);
    flushTimer = window.setTimeout(flush, delay == null ? 250 : delay);
  }

  function flush() {
    flushTimer = null;
    if (!active || sending || !queue.length) return Promise.resolve();
    sending = true;
    var batch = [];
    for (var i = 0; i < queue.length && batch.length < 20; i++) {
      var candidate = batch.concat(queue[i]);
      var candidatePayload = JSON.stringify({
        tracking_id: trackingId,
        customer: config.customer || null,
        events: candidate
      });
      // Keep offline/retry batches below the API request ceiling. Always
      // allow one event through so an unusually large snapshot is not stuck
      // behind later events; the server applies its own per-event ceiling.
      if (batch.length && utf8ByteLength(candidatePayload) > MAX_BATCH_BYTES) break;
      batch = candidate;
    }
    var batchIds = batch.map(function (event) { return event.event_uid; });
    var payload = JSON.stringify({
      tracking_id: trackingId,
      customer: config.customer || null,
      events: batch
    });

    return nativeFetch(config.endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: payload,
      keepalive: payload.length < 60000
    }).then(function (response) {
      if (!response.ok) throw new Error('Activity endpoint returned ' + response.status);
      queue = queue.filter(function (event) { return batchIds.indexOf(event.event_uid) === -1; });
      saveQueue();
      sending = false;
      if (queue.length) scheduleFlush(25);
    }).catch(function () {
      sending = false;
      saveQueue();
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = window.setTimeout(flush, 10000);
    });
  }

  function normalizeCart(cart) {
    var blankItems = [];
    var designLines = [];
    var giftItems = [];
    var designData = [];

    (cart.items || []).forEach(function (item) {
      var properties = item.properties || {};
      var common = {
        key: item.key || null,
        product_id: item.product_id || null,
        variant_id: item.variant_id || item.id || null,
        sku: item.sku || null,
        handle: item.handle || null,
        product_title: item.product_title || item.title || null,
        size: item.variant_title || null,
        quantity: item.quantity || 0,
        unit_price_cents: item.final_price == null ? item.price : item.final_price,
        line_price_cents: item.final_line_price == null ? item.line_price : item.final_line_price
      };

      if (item.handle === 'custom-design' || properties._design_data != null) {
        designLines.push(common);
        if (properties._design_data != null) {
          try {
            designData.push(JSON.parse(properties._design_data));
          } catch (error) {
            designData.push({ parse_error: true, raw: String(properties._design_data).slice(0, 12000) });
            reportAnomaly('cart-design-json-parse-failed', 'cart-snapshot', {
              line_key: item.key || null,
              raw_length: String(properties._design_data).length
            }, { error: error, snapshot: false });
          }
        }
      } else if (properties._free_gift_id != null || properties._free_gift === 'true') {
        common.gift_id = properties._free_gift_id || null;
        giftItems.push(common);
      } else {
        common.color = properties.color || null;
        blankItems.push(common);
      }
    });

    return {
      cart_token: cart.token || null,
      item_count: cart.item_count || 0,
      total_price_cents: cart.total_price || 0,
      tracking_attribute: (cart.attributes || {})[config.cartAttributeKey] || null,
      blanks: blankItems,
      custom_design_lines: designLines,
      custom_design_data: designData,
      gifts: giftItems
    };
  }

  function inspectCartInvariants(cartSnapshot) {
    var blanks = {};
    var required = {};
    var expectedDesignQty = 0;
    var actualDesignQty = 0;
    var violations = [];

    (cartSnapshot.blanks || []).forEach(function (item) {
      var handle = item.handle || '';
      var size = item.size || '';
      blanks[handle] = blanks[handle] || {};
      blanks[handle][size] = (blanks[handle][size] || 0) + (item.quantity | 0);
    });
    (cartSnapshot.custom_design_lines || []).forEach(function (item) {
      actualDesignQty += item.quantity | 0;
    });
    (cartSnapshot.custom_design_data || []).forEach(function (payload) {
      if (!payload || payload.parse_error || !Array.isArray(payload.shirts)) return;
      payload.shirts.forEach(function (shirt) {
        if (!shirt || !shirt.key) return;
        required[shirt.key] = required[shirt.key] || {};
        var designs = Array.isArray(shirt.customDesigns) ? shirt.customDesigns : [shirt];
        designs.forEach(function (design) {
          Object.keys((design && design.quantities) || {}).forEach(function (size) {
            var quantity = ((design.quantities || {})[size] | 0);
            if (quantity <= 0) return;
            required[shirt.key][size] = (required[shirt.key][size] || 0) + quantity;
            expectedDesignQty += quantity;
          });
        });
      });
    });

    Object.keys(required).forEach(function (handle) {
      Object.keys(required[handle]).forEach(function (size) {
        var blankQty = (blanks[handle] && blanks[handle][size]) || 0;
        if (blankQty < required[handle][size]) {
          violations.push({
            type: 'blank-coverage-shortage',
            handle: handle,
            size: size,
            blank_quantity: blankQty,
            required_design_quantity: required[handle][size],
            shortage_quantity: required[handle][size] - blankQty
          });
        }
      });
    });
    if (actualDesignQty !== expectedDesignQty) {
      violations.push({
        type: 'design-line-quantity-mismatch',
        design_line_quantity: actualDesignQty,
        assigned_design_quantity: expectedDesignQty
      });
    }
    if ((expectedDesignQty > 0 && cartSnapshot.custom_design_lines.length !== 1) ||
        (expectedDesignQty === 0 && cartSnapshot.custom_design_lines.length > 0)) {
      violations.push({
        type: 'design-line-count-mismatch',
        expected_line_count: expectedDesignQty > 0 ? 1 : 0,
        actual_line_count: cartSnapshot.custom_design_lines.length
      });
    }
    if (violations.length) {
      reportAnomaly('cart-snapshot-invariant-violation', 'cart-snapshot', {
        violations: violations.slice(0, 50)
      }, {
        severity: 'warning',
        cartToken: cartSnapshot.cart_token,
        snapshot: false
      });
    }
  }

  function logCartSnapshot(reasons, suppliedCart) {
    if (!active) return Promise.resolve();
    var cartPromise = suppliedCart
      ? Promise.resolve(suppliedCart)
      : nativeFetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (response) {
          if (!response.ok) throw new Error('Cart snapshot read failed');
          return response.json();
        });

    return cartPromise.then(function (cart) {
      currentCartToken = cart.token || currentCartToken;
      var normalizedCart = normalizeCart(cart);
      enqueue('cart-update', 'shopify-cart', {
        reasons: reasons || [],
        cart: normalizedCart
      }, { cartToken: cart.token || null, immediate: true });
      inspectCartInvariants(normalizedCart);
    }).catch(function (error) {
      enqueue('activity-error', 'cart-snapshot', {
        message: error && error.message ? String(error.message).slice(0, 500) : 'Cart snapshot failed'
      });
    });
  }

  function scheduleCartSnapshot(reason) {
    if (!active) return;
    if (reason && pendingSnapshotReasons.indexOf(reason) === -1) pendingSnapshotReasons.push(reason);
    if (snapshotTimer) window.clearTimeout(snapshotTimer);
    snapshotTimer = window.setTimeout(function () {
      snapshotTimer = null;
      var reasons = pendingSnapshotReasons.slice();
      pendingSnapshotReasons = [];
      logCartSnapshot(reasons);
    }, 700);
  }

  function ensureCartAttribute(snapshotReason) {
    if (!active) return Promise.resolve();
    if (cartAttributePromise) return cartAttributePromise;
    var cartBarrier = window.CDCart && typeof window.CDCart.waitForLineUpdates === 'function'
      ? window.CDCart.waitForLineUpdates().catch(function () { /* the cart UI already reports its own error */ })
      : Promise.resolve();
    cartAttributePromise = cartBarrier.then(function () {
      return nativeFetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart attribute read failed');
        return response.json();
      })
      .then(function (cart) {
        currentCartToken = cart.token || currentCartToken;
        if ((cart.attributes || {})[config.cartAttributeKey] === trackingId) {
          cartAttributeRetryCount = 0;
          if (snapshotReason) return logCartSnapshot([snapshotReason], cart);
          return null;
        }
        var attributes = {};
        attributes[config.cartAttributeKey] = trackingId;
        return nativeFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attributes })
        }).then(function (response) {
          if (!response.ok) throw new Error('Cart attribute update failed');
          return response.json();
        }).then(function (updatedCart) {
          cartAttributeRetryCount = 0;
          currentCartToken = updatedCart.token || currentCartToken;
          return logCartSnapshot([snapshotReason || 'tracking-attribute-attached'], updatedCart);
        });
      })
      .catch(function (error) {
        if (cartAttributeRetryCount < 2) {
          cartAttributeRetryCount += 1;
          window.setTimeout(function () { ensureCartAttribute(snapshotReason); }, 1200);
          return;
        }
        cartAttributeRetryCount = 0;
        enqueue('activity-error', 'cart-attribution', {
          message: error && error.message ? String(error.message).slice(0, 500) : 'Cart attribution failed'
        });
      }).then(function (result) {
        cartAttributePromise = null;
        return result;
      });
    return cartAttributePromise;
  }

  function activate(action, source, element) {
    var previousId = active ? trackingId : null;
    if (!active) {
      trackingId = uuid();
      active = true;
      queue = [];
    }
    writeCookie(trackingId);
    enqueue(action, source, {
      tracking_started: !previousId,
      cookie_expires_in_days: COOKIE_DAYS,
      handle: element && element.getAttribute ? element.getAttribute('data-handle') : null
    }, { isTrigger: true, immediate: true });
    ensureCartAttribute('tracking-trigger');
  }

  function describeControl(element) {
    if (!element || !element.getAttribute) return null;
    return {
      control: element.getAttribute('data-cd') || element.getAttribute('data-action') || element.id || null,
      handle: element.getAttribute('data-handle') || null,
      design_index: element.getAttribute('data-design-idx') || null,
      placement: element.getAttribute('data-pid') || null,
      size: element.getAttribute('data-size') || null
    };
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var banner = event.target.closest('#banner-customize-btn');
    var cartAdd = event.target.closest('[data-action="add-custom"]');
    var pdpAdd = event.target.closest('#pdpAddCustomDesign');
    var landingCta = event.target.closest('.cdlp .cdlp-cta');
    var landingProduct = event.target.closest('.cdlp .cdlp-card');
    if (banner) {
      activate('customize-shirts', 'cart-banner', banner);
      return;
    }
    if (cartAdd) {
      activate('add-custom-design', 'cart-line-item', cartAdd);
      return;
    }
    if (pdpAdd) {
      activate('add-custom-design', 'pdp', pdpAdd);
      return;
    }
    if (!active) return;

    if (landingCta) {
      enqueue('start-designing', 'custom-design-landing', {
        cta_location: landingCta.closest('.cdlp-hero') ? 'hero' :
          (landingCta.closest('.cdlp-bottom') ? 'bottom' : 'unknown'),
        destination_url: safeUrl(landingCta.href || landingCta.getAttribute('href'))
      }, { immediate: true });
      return;
    }
    if (landingProduct) {
      enqueue('landing-product-click', 'custom-design-landing', {
        product_handle: landingProduct.getAttribute('data-product-handle') || null,
        destination_url: safeUrl(landingProduct.href || landingProduct.getAttribute('href'))
      }, { immediate: true });
      return;
    }

    var checkout = event.target.closest('#checkoutBtn, .btn-checkout, [name="checkout"]');
    if (checkout) {
      enqueue('checkout-click', 'cart', describeControl(checkout), { immediate: true });
      scheduleCartSnapshot('checkout-click');
      return;
    }
    var designControl = event.target.closest('[data-cd]');
    if (designControl) {
      enqueue('custom-design-ui', 'design-modal', describeControl(designControl));
      return;
    }
    var cartControl = event.target.closest('.cart_items [data-action]');
    if (cartControl) {
      enqueue('cart-ui', 'cart', describeControl(cartControl));
    }
  }, true);

  document.addEventListener('change', function (event) {
    if (!active || !event.target || !event.target.matches) return;
    if (event.target.matches('.cart_items .qty-inp')) {
      var row = event.target.closest('.vrow');
      enqueue('cart-quantity-input', 'cart', {
        handle: row ? row.getAttribute('data-handle') : null,
        size: row && row.querySelector('.vrow-size') ? row.querySelector('.vrow-size').textContent.trim() : null,
        requested_quantity: parseInt(event.target.value, 10) || 0
      });
    }
  }, true);

  function installCartMutationObservers() {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      return nativeFetch(input, init).then(function (response) {
        if (active && !response.ok && isRelevantRequest(url)) {
          reportAnomaly('http-response-failed', 'network-fetch', {
            method: method,
            request_url: safeUrl(url),
            status: response.status || null,
            status_text: response.statusText ? String(response.statusText).slice(0, 250) : null
          }, { snapshot: CART_MUTATION_PATTERN.test(url) });
        }
        if (active && method !== 'GET' && response.ok && CART_MUTATION_PATTERN.test(url)) {
          scheduleCartSnapshot(method + ' ' + String(url).split('?')[0]);
        }
        return response;
      }).catch(function (error) {
        if (active && isRelevantRequest(url)) {
          reportAnomaly('network-request-failed', 'network-fetch', {
            method: method,
            request_url: safeUrl(url)
          }, { error: error, snapshot: CART_MUTATION_PATTERN.test(url) });
        }
        throw error;
      });
    };

    if (!window.XMLHttpRequest) return;
    var nativeOpen = window.XMLHttpRequest.prototype.open;
    var nativeSend = window.XMLHttpRequest.prototype.send;
    window.XMLHttpRequest.prototype.open = function (method, url) {
      this.__sibCdActivityMethod = String(method || 'GET').toUpperCase();
      this.__sibCdActivityUrl = String(url || '');
      return nativeOpen.apply(this, arguments);
    };
    window.XMLHttpRequest.prototype.send = function () {
      var xhr = this;
      if (active && isRelevantRequest(xhr.__sibCdActivityUrl || '')) {
        xhr.addEventListener('loadend', function () {
          if (xhr.status >= 200 && xhr.status < 300 &&
              xhr.__sibCdActivityMethod !== 'GET' && CART_MUTATION_PATTERN.test(xhr.__sibCdActivityUrl || '')) {
            scheduleCartSnapshot(xhr.__sibCdActivityMethod + ' ' + xhr.__sibCdActivityUrl.split('?')[0]);
          } else if (xhr.status < 200 || xhr.status >= 300) {
            reportAnomaly('xhr-request-failed', 'network-xhr', {
              method: xhr.__sibCdActivityMethod,
              request_url: safeUrl(xhr.__sibCdActivityUrl),
              status: xhr.status || null,
              status_text: xhr.statusText ? String(xhr.statusText).slice(0, 250) : null
            }, { snapshot: CART_MUTATION_PATTERN.test(xhr.__sibCdActivityUrl || '') });
          }
        }, { once: true });
      }
      return nativeSend.apply(this, arguments);
    };
  }

  function isRelevantRequest(url) {
    if (!url) return false;
    try {
      var parsed = new URL(String(url), window.location.origin);
      var hostname = parsed.hostname.toLowerCase();

      // Shopify's injected performance telemetry can fail harmlessly and is
      // unrelated to the cart or custom-design workflow.
      if (parsed.pathname === '/api/collect') return false;

      // Relative requests and absolute requests to the current Shopify storefront.
      if (parsed.origin === window.location.origin) return true;
      if (hostname === 'shirtsinbulk.com' ||
          hostname === 'www.shirtsinbulk.com' ||
          hostname === 'shirtsinbulk.myshopify.com') return true;

      // Only SIB-owned API Gateway hosts. Do not allow every execute-api or
      // amazonaws.com host because third-party utilities can use AWS too.
      if (hostname === 'dix7ak1o8b.execute-api.us-east-1.amazonaws.com' ||
          hostname === '7rfb214pth.execute-api.us-east-1.amazonaws.com') return true;

      // Keep the configured activity Lambda covered if its API Gateway ID changes.
      var activityHostname = new URL(config.endpoint, window.location.origin).hostname.toLowerCase();
      return hostname === activityHostname &&
        /^(?:[a-z0-9-]+\.)*execute-api\.[a-z0-9-]+\.amazonaws\.com$/i.test(hostname);
    } catch (error) {
      return false;
    }
  }

  function wireCustomDesignEvents() {
    var designs = window.CustomDesigns;
    if (!designs || typeof designs.on !== 'function') return;
    designs.on('save', function (payload) {
      if (!active) return;
      enqueue('custom-design-save', 'design-modal', {
        shirt_handle: payload && payload.shirtKey,
        design_index: payload && payload.designIdx,
        intended_state: payload && payload.state ? payload.state.cartCustom : null
      }, { immediate: true });
      scheduleCartSnapshot('custom-design-save');
    });
    designs.on('remove', function (payload) {
      if (!active) return;
      enqueue('custom-design-remove', 'design-modal', {
        shirt_handle: payload && payload.shirtKey,
        removed_design: payload && payload.removedDesign,
        intended_state: payload && payload.state ? payload.state.cartCustom : null
      }, { immediate: true });
      scheduleCartSnapshot('custom-design-remove');
    });
    designs.on('change', function (state) {
      if (!active) return;
      if (stateTimer) window.clearTimeout(stateTimer);
      stateTimer = window.setTimeout(function () {
        enqueue('custom-design-state', 'design-modal', {
          intended_state: state && state.cartCustom ? state.cartCustom : null
        });
      }, 300);
    });
  }

  window.addEventListener('error', function (event) {
    if (!active) return;
    reportAnomaly('javascript-error', 'window', {
      message: event.message ? String(event.message).slice(0, 1000) : null,
      filename: safeUrl(event.filename),
      line: event.lineno || null,
      column: event.colno || null
    }, { error: event.error, snapshot: true, allowDuplicate: true });
  });

  window.addEventListener('unhandledrejection', function (event) {
    if (!active) return;
    var reason = event.reason;
    reportAnomaly('unhandled-promise-rejection', 'unhandled-promise', {
      message: reason && reason.message ? String(reason.message).slice(0, 1000) : String(reason || '').slice(0, 1000)
    }, { error: reason, snapshot: true, allowDuplicate: true });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') flush();
  });
  window.addEventListener('pagehide', flush);

  installCartMutationObservers();
  wireCustomDesignEvents();

  // Visiting the marketing page is itself an activation trigger. This starts
  // a timeline for first-time visitors and renews the cookie for returning
  // tracked visitors before the normal page-view event is saved.
  if (/\/pages\/custom-design\/?$/i.test(window.location.pathname)) {
    activate('custom-design-page-visit', 'custom-design-landing', null);
  }

  if (active) {
    enqueue('navigate', 'page-load', {
      title: (config.page || {}).title || document.title,
      viewport: { width: window.innerWidth || null, height: window.innerHeight || null }
    }, { immediate: true });
  }

  window.SIBCustomDesignActivity = {
    isActive: function () { return active; },
    getTrackingId: function () { return active ? trackingId : null; },
    log: enqueue,
    reportAnomaly: reportAnomaly,
    snapshotCart: function (reason) { return logCartSnapshot([reason || 'manual']); }
  };

  pendingAnomalies.forEach(function (pending) {
    if (!pending) return;
    reportAnomaly(pending.code, pending.source, pending.details, pending.options);
  });
})();
